import dayjs from 'dayjs';
import 'dayjs/locale/ko';

// 어제
export const yesterday = dayjs().subtract(1, 'day');
